module.exports = __webpack_public_path__ + "img/newlogo1.3e243b7c.png";